import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
// Top-level components:
import App from './App';
import Faq from './Faq';
import Home from './Home';
import ViewAlert, { tagLoader } from './ViewAlert';
import NewAlert, { tagIdLoader } from './NewAlert';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home/>
  },
  {
    path: "/tags",
    element: <App/>
  },
  {
    path: "/faq",
    element: <Faq/>
  },
  {
    path: "/finder/:owner/:tagId",
    element: <NewAlert/>,
    loader: tagIdLoader
  },
  {
    path: "/f/:owner/:tagId",
    element: <NewAlert/>,
    loader: tagIdLoader
  },
  {
    path: "/alert/:userId/:tagId",
    element: <ViewAlert/>,
    loader: tagLoader
  }
]);

root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
